/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SiteContactInviteResponse } from '../models/SiteContactInviteResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SiteContactRoutesRepository {
  /**
   * Get Site Contact Via Token
   * Returns site contact information via homeowner invite token.
   * @returns SiteContactInviteResponse Successful Response
   * @throws ApiError
   */
  public static siteContactRoutesGetSiteContactViaToken({
    token,
  }: {
    token: string,
  }): CancelablePromise<SiteContactInviteResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/noauth/jobs/site-contact/{token}',
      path: {
        'token': token,
      },
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Validation Error`,
      },
    });
  }
}
